import React from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";

import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
const ActionsMenu = ({ row, onEdit, onDelete, showEdit = true, showDelete = true }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleClose();

    if (onEdit) {
      onEdit(row);
    }
  };

  const handleDelete = () => {
    handleClose();

    if (onDelete) {
      onDelete(row);
    }
  };

  return (
    <>
      <IconButton size="small" onClick={handleClick} aria-label="actions">
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {showEdit && (
          <MenuItem onClick={handleEdit}>
            <EditIcon fontSize="small" sx={{ mr: 1 }} />
            Edit
          </MenuItem>
        )}

        {showDelete && (
          <MenuItem onClick={handleDelete}>
            <DeleteIcon fontSize="small" sx={{ mr: 1 }} />
            Delete
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
ActionsMenu.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  showEdit: PropTypes.bool,
  showDelete: PropTypes.bool,
  row: PropTypes.object.isRequired,
};
export default ActionsMenu;
